import { computed, ref, Ref } from 'vue'

type OffsetInfo = {
  offset: Ref<number>
  limit: Ref<number> | number
}

export type SearchBatchesQuery = OffsetInfo & {
  query: Ref<string>
}

export function useBuildSearchBatchesQuery(
  currentPage: Ref<number>,
  itemsPerPage: Ref<number> = ref(20),
  query: Ref<string>,
): SearchBatchesQuery {
  const offset = computed(() => (currentPage.value - 1) * itemsPerPage.value)

  return {
    offset,
    limit: itemsPerPage,
    query,
  }
}
